var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamDetailsHeaderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3377,
    height: 171,
    viewBox: "0 0 3377 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.425 156.31L-0.00195312 63.8066V107.424L93.0468 170.516H353.08L374.032 156.31H136.425Z",
    fill: "#754B27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.817 32.2226L148.502 0H84.707L142.856 39.6036L195.817 32.2226Z",
    fill: "#AA2500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8652 28.5967C45.8652 22.5369 50.7658 17.6182 56.8256 17.5958L3301.59 5.61093C3310.37 5.57851 3315.65 15.3354 3310.82 22.6653L3217.02 165.002C3214.98 168.099 3211.52 169.959 3207.81 169.949L56.8376 161.778C50.7731 161.762 45.8652 156.841 45.8652 150.777V28.5967Z",
    fill: "#213375"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0098 23.8955C35.0098 20.2501 37.965 17.2949 41.6104 17.2949H3240.04C3243.94 17.2949 3246.98 20.6461 3246.61 24.5212L3234.12 155.74C3233.8 159.127 3230.95 161.715 3227.55 161.715H41.6104C37.965 161.715 35.0098 158.759 35.0098 155.114V23.8955Z",
    fill: "url(#paint0_linear_16246_178598)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1967 0L-0.00390625 57.3096V101.091L148.525 0H84.1967Z",
    fill: "#E07E27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.897 50.6055L46.2003 69.3072L-0.00390625 101.21V57.2061L9.897 50.6055Z",
    fill: "#FFDA00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5992 30.252L75.3524 50.0538L46.1998 69.3055L9.89648 50.6038L39.5992 30.252Z",
    fill: "#F58220"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1021 11.5508L82.5035 45.1038L74.8028 50.0543L39.5996 30.2525L67.1021 11.5508Z",
    fill: "#D9166F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1536 0L96.8048 35.2032L82.5035 45.1041L66.002 12.1011L84.1536 0Z",
    fill: "#50B848"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7053 0L115.507 23.1021L96.8054 35.2032L84.1543 0H95.7053Z",
    fill: "#374EA2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.857 0L132.558 11.001L113.857 24.2022L95.7051 0H113.857Z",
    fill: "#DA2128"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16246_178598",
    x1: 35.0098,
    y1: 89.5047,
    x2: 3280.86,
    y2: 89.5047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216182
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203376"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamDetailsHeaderBg);
export default __webpack_public_path__ + "static/media/teamDetailsHeaderBg.3680cf3d7e2fa4694b7c73b958107dd0.svg";
export { ForwardRef as ReactComponent };